import type {FarmState} from './model';
export function defaultState(): FarmState {
  return {
    cerdas:[], verracos:[], montas:[], celos:[], repeticiones:[], partos:[], camadas:[],
    lotes:[], espacios:[], espaciosCerdas:[], alimentacion:[], racionesLactancia:[], pesajes:[], mortalidad:[], fasesAlimento:[], transferenciasLechones:[], tareasManual:[],
    protocolos:{
      reproduccion:[
        {id:'r1',dia:79,nombre:'Ecoli',aplicaA:'primerizas',detalle:'Vacuna Ecoli',activo:true},
        {id:'r2',dia:90,nombre:'APP + 1 libra extra de comida',aplicaA:'todas',detalle:'',activo:true},
        {id:'r3',dia:93,nombre:'SE-VE',aplicaA:'todas',detalle:'',activo:true},
        {id:'r4',dia:94,nombre:'Hierro + Ecoli',aplicaA:'todas',detalle:'',activo:true},
        {id:'r5',dia:105,nombre:'Mezclar lactancia',aplicaA:'todas',detalle:'Cambio de alimento',activo:true},
        {id:'r6',dia:108,nombre:'Subir a paridera',aplicaA:'todas',detalle:'6 días antes del parto probable',activo:true},
        {id:'r7',dia:114,nombre:'Fecha probable de parto',aplicaA:'todas',detalle:'',activo:true},
      ],
      posparto:[
        {id:'p1',dia:1,nombre:'Compol B',detalle:'',activo:true},
        {id:'p2',dia:10,nombre:'Parvo',detalle:'',activo:true},
        {id:'p3',dia:14,nombre:'Ivermectina Duo + Compol ADE',detalle:'',activo:true},
        {id:'p4',dia:21,nombre:'SE-VE',detalle:'',activo:true},
      ],
      lechones:[
        {id:'l1',dia:1,nombre:'Hierro + Coxizuril',detalle:'',activo:true},
        {id:'l2',dia:3,nombre:'Descole + Papilla',detalle:'',activo:true},
        {id:'l3',dia:5,nombre:'Alimento fase 1 + Minoxel',detalle:'',activo:true},
        {id:'l4',dia:15,nombre:'Castración',detalle:'',activo:true},
        {id:'l5',dia:20,nombre:'Duo',detalle:'',activo:true},
        {id:'l6',dia:21,nombre:'Hemoplex',detalle:'',activo:true},
      ],
      lote:[
        {id:'lt1',dia:49,nombre:'Primera dosis APP',detalle:'',activo:true},
        {id:'lt2',dia:105,nombre:'Desparasitación + alimento engorde',detalle:'',activo:true},
      ],
      reemplazoCerda:[], reemplazoVerraco:[],
    },
    procedimientos:[],
    configuracion:{nacimientoDiaCero:true},
    tareasHechas:[],
    eventOverrides:{},
    counters:{lote:0,cerdaAuto:0}
  };
}
